import PropTypes from 'prop-types';
import React from 'react';
import {Modal} from 'react-bootstrap';
import './modalStyle.scss';

 function ShowModal(props) {
    var {toggleModel, show , title, renderModalBody} = props;
    return (
        <>
            <Modal className="modal-about"  show={show} onHide={toggleModel}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {renderModalBody}
                </Modal.Body>
            </Modal>
        </>
    );
}

ShowModal.propTypes = {
    toggleModel: PropTypes.func,
    show: PropTypes.func,
    title: PropTypes.string,
    renderModalBody: PropTypes.any
};

export default ShowModal;